import { Add, ArrowForward } from '@mui/icons-material';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../components/PageHeader';
import { PageContent, PageLayout } from '../../layout';
import { ClaimsTable } from './claims/components/ClaimsTable';
import { InvoiceTable } from './Invoices/components/InvoiceTable';

export const Dashboard = () => {
  const { t } = useTranslation();
  return (
    <PageLayout>
      <PageHeader
        title={t('dashboard')}
        backRouteTo={null}
        action={
          <Button size={'large'} component={Link} to={'/upload'} startIcon={<Add />} variant={'contained'}>
            {t('addInvoice')}
          </Button>
        }
      />
      <PageContent
        sx={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          gap: 4,
        }}
      >
        <Paper component={Stack} flex={1} gap={2} width={'100%'} direction={'column'} mt={2} p={2}>
          <Box width={'100%'} display={'flex'} flex-wrap={'wrap'} gap={2} justifyContent={'space-between'}>
            <Typography variant={'h2'}>{t('invoices.dashboard.overview')}</Typography>
            <Button component={Link} to={'/invoices'} endIcon={<ArrowForward />} variant={'outlined'}>
              {t('invoices.goto')}
            </Button>
          </Box>
          <InvoiceTable id={'dashboard-invoices'} isOverview />
        </Paper>
        <Paper component={Stack} flex={1} gap={2} width={'100%'} direction={'column'} p={2}>
          <Box width={'100%'} display={'flex'} flex-wrap={'wrap'} gap={2} justifyContent={'space-between'}>
            <Typography variant={'h2'}>{t('claims.dashboard.overview')}</Typography>
            <Button component={Link} to={'/claims'} endIcon={<ArrowForward />} variant={'outlined'}>
              {t('claims.goto')}
            </Button>
          </Box>
          <ClaimsTable id={'dashboard-claims'} isOverview />
        </Paper>
      </PageContent>
    </PageLayout>
  );
};
